<template lang="pug">
div
  .h-vertical-align-container(v-if="modalShow")
    .modal__close(@click='overlay()')
    .modal__overlay(@click='overlay()')
    .videoModal__wrapper
      .fluid__video#fluid__video--tutorial(v-html='ytVideo') {{ytVideo}}

  section.learningLab__section
    .learningLab__section--intro
      h1 Learning Lab Tutorials
      p Ready to create cinemagraphs with Flixel Cinemagraph Pro? Want to learn more about what we do at Flixel? Check out tutorials and behind-the-scenes content created by the Flixel Team and professional Flixel Artists to get started on your cinemagraph journey.

  section(v-scroll='handleScroll')
    .learningLab__content
      aside.learningLab__content--menu
        ul(ref='tutorialMenu')
          li
            a.menu--active(@click='scrollTo("#gettingstarted")') Getting Started
          li
            a(@click='scrollTo("#cinemagraphpro")')  Cinemagraph Pro for macOS Tutorials
          li
            a(@click='scrollTo("#cinemagraphproios")') Cinemagraph Pro for iOS Tutorials
          li
            a(@click='scrollTo("#persecond")') Persecond for macOS Tutorials
          li
            a(@click='scrollTo("#sharingcinemagraphs")') Sharing Cinemagraphs Across Social Media, Web and Presentations
          li
            a(@click='scrollTo("#facebookprofilevideos")') Facebook Profile Videos
          li
            a(@click='scrollTo("#flixelcommunity")') Flixel Community
          li
            a(@click='scrollTo("#learnaboutflixel")') Learn About Flixel
      .learningLab__content--videos
        select(v-model='videoOptions' v-on:change='scrollTo(videoOptions)')
          option(value='' selected disabled) Jump to Category
          option(value='#gettingstarted') Getting Started
          option(value="#cinemagraphpro") Cinemagraph Pro for macOS Tutorials
          option(value="#cinemagraphproios") Cinemagraph Pro for iOS Tutorials
          option(value="#persecond") Persecond for macOS Tutorials
          option(value="#sharingcinemagraphs") Sharing Cinemagraphs Across Social Media, Web and Presentations
          option(value="#facebookprofilevideos") Facebook Profile Videos
          option(value="#flixelcommunity") Flixel Community
          option(value="#learnaboutflixel") Learn About Flixel

        section.noBoxShadow#gettingstarted(ref='gettingstarted')
          h2 Getting Started
          .learningLab__content--grid
            .grid__item
              a(href='https://www.youtube.com/watch?v=ddPsIsWdoJQ' @click='ytModal($event)')
                .grid__item--image.grid__item--imageLarge
                  img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphproformac@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphproformac.png 1x')
                  .playbtn
              .grid__item--content
                h3 Getting Started with Cinemagraph Pro for macOS
                p Learn how to compose a cinemagraph, mask, create a bounce loop, use presets, export, and upload your cinemagraph using Cinemagraph Pro for macOS
            .grid__item
              a(href='https://www.youtube.com/watch?v=VTyk8dvsxD8' @click='ytModal($event)')
                .grid__item--image.grid__item--imageLarge
                  img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphproios@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphproios.png 1x')
                  .playbtn
              .grid__item--content
                h3 Getting Started with Cinemagraph Pro for iOS
                p Learn how to compose a cinemagraph, mask, create a bounce loop, use presets, export, and upload your cinemagraph using Cinemagraph Pro for iOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=vy73FLTcv34' @click='ytModal($event)')
                .grid__item--image.grid__item--imageLarge
                  img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/persecond@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/persecond.png 1x')
                  .playbtn
              .grid__item--content
                h3 Introduction to Persecond for macOS
                p Learn to make beautiful time lapses videos with Persecond for macOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=1SkkNirjTUE' @click='ytModal($event)')
                .grid__item--image.grid__item--imageLarge
                  img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/flixeltv@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/flixeltv.png 1x')
                  .playbtn
              .grid__item--content
                h3 Introduction to Flixel TV for Apple TV
                p Watch this tour of Flixel TV, the only way to experience your cinemagraphs on Apple TV.
            .grid__item
              a(href='https://www.youtube.com/watch?v=sZKdTJhWkDw' @click='ytModal($event)')
                .grid__item--image
                  img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/filmingtipsmacos@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/filmingtipsmacos.png 1x')
                  .playbtn
              .grid__item--content
                h3 Best Filming Tips for Creating Cinemagraphs using a DSLR
                p Learn the ideal camera settings for recording footage on your DSLR and how to compose a cinemagraph.
            .grid__item
              a(href='https://www.youtube.com/watch?v=ykiVH9hqxb4' @click='ytModal($event)')
                .grid__item--image
                  img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/filmingtipsforiphoneandipad@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/filmingtipsforiphoneandipad.png 1x')
                  .playbtn
              .grid__item--content
                h3 Filming Tips for Creating Cinemagraphs on iPhone or iPad
                p Learn the ideal camera settings for recording footage on your iOS device and how to compose a cinemagraph. 

        section.noBoxShadow#cinemagraphpro(ref='cinemagraphpro')
          h2 Cinemagraph Pro for macOS Tutorials
          .learningLab__content--grid
            .grid__item
              a(href='https://www.youtube.com/watch?v=ddPsIsWdoJQ' @click='ytModal($event)')
                .grid__item--image.grid__item--imageLarge
                  img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphproformac@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphproformac.png 1x')
                  .playbtn
              h3 Getting Started | Create Cinemagraphs with Cinemagraph Pro for macOS
              p Learn how to compose a cinemagraph, mask, create a bounce loop, use presets, export, and upload your cinemagraph using Cinemagraph Pro for macOS
            .grid__item
              a(href='https://www.youtube.com/watch?v=KvEyYh2LN1c' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/intermediatemacOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/intermediatemacOS.png 1x')
                .playbtn
              h3 Intermediate | Create Cinemagraphs with Cinemagraph Pro for macOS
              p Learn how to create a product shot cinemagraph, edit liquids in motion, precise masking, repeat loops and colour adjustments.
            .grid__item
              a(href='https://www.youtube.com/watch?v=0eI5QcKrkZ8' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedtutorialmacOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedtutorialmacOS.png 1x')
                .playbtn
              h3 Advanced | Create Cinemagraphs with Cinemagraph Pro for macOS
              p Learn how to isolate movements on subjects, create the perfect loop and customized presets in Cinemagraph Pro for macOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=8XCZahV5Em0' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/textlogomacOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/textlogomacOS.png 1x')
                .playbtn
              h3 How to Add Images & Text
              p Learn how to add images and text on top of your cinemagraphs in Cinemagraph Pro for macOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=Tn4Gs4XYWbQ' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedmaskingmacOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedmaskingmacOS.png 1x')
                .playbtn
              h3 How to Create a Precise Mask
              p Learn how to adjust the size, hardness, and opacity of the brush tool to precisely mask overlapping motion in Cinemagraph Pro for macOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=1OmghezJzBM' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/bouncemacOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/bouncemacOS.png 1x')
                .playbtn
              h3 How to Create a Perfect Bounce Loop
              p Learn how to shoot and create cinemagraphs with a perfect bounce loop in Cinemagraph Pro for macOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=qeUwnqevCYI' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/repeatmacOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/repeatmacOS.png 1x')
                .playbtn
              h3 How to Create a Perfect Repeat Loop and Use Crossfade
              p Learn how to shoot cinemagraphs with a repeating motion and use the trim and crossfade tools to create a perfect repeat loop in Cinemagraph Pro for macOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=IRLuJ-pBQpg' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/touchupsandadjustments@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/touchupsandadjustments.png 1x')
                .playbtn
              h3 How to Touch Up and Import a Still Image
              p Learn how to touch up your still image using a third-party editing application and import your edited still image for your cinemagraph in Cinemagraph Pro for macOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=dcxOh2174BA' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/stillimages@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/stillimages.png 1x')
                .playbtn
              h3 How to Create a Cinemagraph with a Floating Subject
              p Learn how to capture your video and still image separately to make your subject levitate using Cinemagraph Pro for macOS.

        section.noBoxShadow#cinemagraphproios(ref='cinemagraphproios')
          h2 Cinemagraph Pro for iOS Tutorials
          .learningLab__content--grid
            .grid__item
              a(href='https://www.youtube.com/watch?v=VTyk8dvsxD8' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/gettingstartediOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/gettingstartediOS.png 1x')
                .playbtn
              h3 Getting Started | Create Cinemagraphs on iPhones and iPads with Cinemagraph Pro for iOS
              p Learn how to compose a cinemagraph, mask, create a bounce loop, use presets, export, and upload your cinemagraph using Cinemagraph Pro for iOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=TrKN85c64Y0' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/intermediateiOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/intermediateiOS.png 1x')
                .playbtn
              h3 Intermediate | Create Cinemagraphs on iPhones and iPads with Cinemagraph Pro for iOS
              p Learn how to create a product shot cinemagraph on iPhones, edit liquids in motion, precise masking, repeat loops, and colour adjustments with presets in Cinemagraph Pro for iOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=z5gH6L6Wb5E' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedtutorialios@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedtutorialios.png 1x')
                .playbtn
              h3 Advanced | Create Cinemagraphs on iPhones and iPads with Cinemagraph Pro for iOS
              p Learn how to isolate movements on subjects, create the perfect loop, and colour adjustments from scratch in Cinemagraph Pro for iOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=2QSZRVnLqE0' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/textlogoiOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/textlogoiOS.png 1x')
                .playbtn
              h3 How to Add Images & Text
              p Learn how to add images and text on top of your cinemagraphs in Cinemagraph Pro for iOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=MbmBlMbIgaE' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedmaskingios@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/advancedmaskingios.png 1x')
                .playbtn
              h3 How to Precisely Mask Cinemagraphs with Overlapping Motion
              p Learn how to adjust the size, hardness, and opacity of the brush tool to precisely mask overlapping motion in Cinemagraph Pro for iOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=CAAEgsqiAUw' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/bounceios@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/bounceios.png 1x')
                .playbtn
              h3 How to Create a Perfect Bounce Loop
              p Learn how to shoot and create cinemagraphs with a perfect bounce loop using the trim tool in Cinemagraph Pro for iOS.
            .grid__item
              a(href='https://www.youtube.com/watch?v=kA1VatH6_rk' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/repeatiOS@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/repeatiOS.png 1x')
                .playbtn
              h3 How to Create a Perfect Repeat Loop and Crossfade
              p Learn how to shoot cinemagraphs with a repeating motion and use the trim and crossfade tools to create a perfect repeat loop in Cinemagraph Pro for iOS.

        section.noBoxShadow#persecond(ref='persecond')
          h2 Persecond for macOS Tutorials
          .learningLab__content--grid
            .grid__item
              a(href='https://www.youtube.com/watch?v=vy73FLTcv34' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/persecondtutorial@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/persecondtutorial.png 1x')
                .playbtn
              h3 Introduction to Persecond for macOS
              p This tutorial shows you how easy it is to make beautiful time lapses with Persecond.
            .grid__item
              a(href='https://www.youtube.com/watch?v=nU9iqYo1TpI' @click='ytModal($event)')
                img.lazy(data-src='https://i1.ytimg.com/vi/nU9iqYo1TpI/maxresdefault.jpg')
                .playbtn
              h3 Beautiful Time Lapses Created Using Persecond
              p Check out some time lapse examples created with Persecond.

        section.noBoxShadow#sharingcinemagraphs(ref='sharingcinemagraphs')
          h2 Sharing Cinemagraphs Across Social Media, Web and Presentations
          .learningLab__content--grid
            .grid__item
              a(href='https://www.youtube.com/watch?v=SE2Ol4AMYvo' @click='ytModal($event)')
                img.lazy(data-src='https://i1.ytimg.com/vi/SE2Ol4AMYvo/maxresdefault.jpg')
                .playbtn
              h3 Examples of Cinemagraphs in PowerPoint and Keynote
              p Transform stale presentations by using cinemagraphs in Powerpoint and Keynote.
            .grid__item
              a(href='https://www.youtube.com/watch?v=AFQdqjz65q4' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphfb@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/cinemagraphfb.png 1x')
                .playbtn
              h3 How to Post Cinemagraphs on Facebook
              p Learn how to post cinemagraphs on Facebook on desktop and mobile.
            .grid__item
              a(href='https://www.youtube.com/watch?v=BhD3UU4ue00' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/postsnapchat@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/postsnapchat.png 1x')
                .playbtn
              h3 How to Post Cinemagraphs on Snapchat
              p Learn how to post cinemagraphs on Snapchat using Memories.
            .grid__item
              a(href='https://www.youtube.com/watch?v=Z3mdOx7xod4' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/postinstagram@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/postinstagram.png 1x')
                .playbtn
              h3 How to Post Cinemagraphs on Instagram
              p Learn how to post cinemagraphs on Instagram on mobile.
            .grid__item
              a(href='https://www.youtube.com/watch?v=hylc4BbxZBY' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/instagramstories@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/instagramstories.png 1x')
                .playbtn
              h3 How to Post Cinemagraphs on Instagram Stories
              p Learn how to post and style your cinemagraphs on Instagram Stories.
            .grid__item
              a(href='https://www.youtube.com/watch?v=wJ8U9jAJ7LA' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/posttwitter@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/posttwitter.png 1x')
                .playbtn
              h3 How to Post Cinemagraphs on Twitter
              p Learn how to post cinemagraphs on Twitter on desktop and mobile.

        section.noBoxShadow#facebookprofilevideos(ref='facebookprofilevideos')
          h2 Facebook Profile Videos
          .learningLab__content--grid
            .grid__item
              a(href='https://www.youtube.com/watch?v=CeU1BrvB-Vg' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/fbprofilecinemagraph@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/fbprofilecinemagraph.png 1x')
                .playbtn
              h3 Flixel Makes Facebook Cinemagraph Profile Videos With Facebook Canada
              p The Flixel team headed to Facebook Canada headquarters to create Facebook Cinemagraph Profile Videos with staff. Take a behind-the-scenes look at the visit.

        section.noBoxShadow#flixelcommunity(ref='flixelcommunity')
          h2 Flixel Community
          .learningLab__content--grid
            .grid__item
              a(href='https://www.youtube.com/watch?v=pT1Jn86r-C4' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/lindsayadler@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/lindsayadler.png 1x')
                .playbtn
              h3 Lindsay Adler Shoots a Wedding Cinemagraph
              p Take a look at how Lindsay Adler shoots and edits wedding cinemagraphs using Flixel Cinemagraph Pro.
            .grid__item
              a(href='https://www.youtube.com/watch?v=8fW8p6cbQbo' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/jonkane@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/jonkane.png 1x')
                .playbtn
              h3 The Creator Series: Jon Kane Houldsworth
              p Jon Kane Houldsworth is a New Zealand-based Flixel Wizard whose work screams visual mastermind. Learn his story in The Creator Series.
            .grid__item
              a(href='https://www.youtube.com/watch?v=71bPMCWlimI' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/alexandremiguel@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/alexandremiguel.png 1x')
                .playbtn
              h3 The Creator Series: Alexandre Miguel
              p Meet Flixel Wizard Alexandre Miguel, the world’s most prolific cinemagraph creator with over 3,000 living photos.
            .grid__item
              a(href='https://www.youtube.com/watch?v=11d9y3Xs6Qk' @click='ytModal($event)')
                img.lazy(data-src='https://img.youtube.com/vi/11d9y3Xs6Qk/mqdefault.jpg')
                .playbtn
              h3 The Creator Series: Thomas Brand
              p Meet Thomas Brand, Flixel Wizard and top cinemagraph creator from Munich, Germany.
            .grid__item
              a(href='https://www.youtube.com/watch?v=MNPQuRCWvgU' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/petra@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/petra.png 1x')
                .playbtn
              h3 Petra Švajger Shoots Fashion Cinemagraphs
              p Check out how pro photographer Petra Švajger shoots fashion cinemagraphs in this behind-the-scenes video.
            .grid__item
              a(href='https://www.youtube.com/watch?v=25e6Dokxhkg' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/flixelwalk@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/flixelwalk.png 1x')
                .playbtn
              h3 Flixel Walk with Moment in New York
              p We partnered with our friends at Moment for a Flixel Walk to connect with local New York creators and shoot cinemagraphs in Brooklyn Bridge Park using iPhones.
            .grid__item
              a(href='https://www.youtube.com/watch?v=YtUjhdGwPFw' @click='ytModal($event)')
                img.lazy(data-src='https://i1.ytimg.com/vi/YtUjhdGwPFw/maxresdefault.jpg')
                .playbtn
              h3 Flixel Walk with Joby in Las Vegas
              p We partnered with our friends at Joby for a Flixel Walk to shoot cinemagraphs with local creators in Las Vegas, Nevada.

        section.noBoxShadow#learnaboutflixel(ref='learnaboutflixel')
          h2 Learn about Flixel
          .learningLab__content--grid
            .grid__item
              a(href='https://www.youtube.com/watch?v=Yv6hGB6SFQs' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/flixelCTA@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/flixelCTA.png 1x')
                .playbtn
              h3 Flixel and the CTA Host #CINEMAGRAPH in New York
              p Take a look at #CINEMAGRAPH, a one-day event in New York City that showcased how cinemagraphs are evolving as a storytelling medium in the advertising world.
            .grid__item
              a(href='https://www.youtube.com/watch?v=g7y3NSMBJLY' @click='ytModal($event)')
                img.lazy(data-src='https://i1.ytimg.com/vi/g7y3NSMBJLY/maxresdefault.jpg')
                .playbtn
              h3 Flixel Creates Cinemagraphs at Techweek 2016
              p Go behind-the-scenes of the Flixel Booth created for Techweek 2016 using iPads and Cinemagraph Pro for iOS with Team Flixel.
            .grid__item
              a(href='https://www.youtube.com/watch?v=KmVVSEgMSPA' @click='ytModal($event)')
                img.lazy(data-srcset='https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/holidaycinemagraphs@2x.png 2x, https://cdn.flixel.com/static/static-web/learninglab/tutorial_previews/holidaycinemagraphs.png 1x')
                .playbtn
              h3 Flixel and Facebook Create Holiday Cinemagraphs at the Media Innovation Awards 2016
              p Check out the Flixel Booth created by Team Flixel and Facebook Canada for the Media Innovation Awards hosted by Marketing Magazine.
            .grid__item
              a(href='https://www.youtube.com/watch?v=6dClChAFrPY' @click='ytModal($event)')
                img.lazy(data-src='https://i1.ytimg.com/vi/6dClChAFrPY/maxresdefault.jpg')
                .playbtn
              h3 First Ever Cinemagraph TV Ad by truTV and Flixel Studios
              p Take a look at the first ever cinemagraph TV ad created by truTV and Flixel Studios for Pizza Hut.
            .grid__item
              a(href='https://www.youtube.com/watch?v=7WQdeu5NjRE' @click='ytModal($event)')
                img.lazy(data-src='https://i1.ytimg.com/vi/7WQdeu5NjRE/maxresdefault.jpg')
                .playbtn
              h3 What is a Cinemagraph?
              p Cinemagraphs are the next great storytelling medium, but how many people know what is a cinemagraph? We took to the busy streets of Toronto to see how people react to living photos.
</template>

<script>
import Scroll from 'directives/Scroll.js';

export default {
  name: 'Tutorials',
  data() {
    return {
      modalShow: false,
      videoOptions: '',
      ytVideo: '',
    };
  },
  metaInfo: {
    title: 'Cinemagraph Tutorials and Behind the Scenes | Flixel',
    meta: [
      {
        'property': 'image',
        'content': 'https://cdn.flixel.com/static/static-web/LearningLab.png',
      },
      {
        'property': 'description',
        'content': 'Learn how to create and share cinemagraphs using Flixel tutorials, and take a behind-the-scenes look at the Flixel community.',
      },
    ],
  },
  directives: {
    scroll: Scroll,
  },
  mounted() {
    const myLazyLoad = new LazyLoad({
      elements_selector: 'iframe, .lazy',
    });
  },
  methods: {
    handleScroll() {
      const tutorialPos = this.$refs.gettingstarted.offsetTop;
      const currentPos = window.pageYOffset;
      if (currentPos >= tutorialPos) {
        this.$refs.tutorialMenu.classList.add('fixed');
        $('.learningLab__content--videos section').each(function (i) {
          if ($(this).position().top <= currentPos + 500) {
            $('aside a.menu--active').removeClass('menu--active');
            $('aside a').eq(i).addClass('menu--active');
          }
        });
      } else {
        this.$refs.tutorialMenu.classList.remove('fixed');
      }
    },
    scrollTo(id) {
      $('html, body').animate({ scrollTop: $(id).offset().top - 100 }, 800);
    },
    ytModal($event) {
      $event.preventDefault();
      const ytURL = $event.currentTarget.getAttribute('href');
      const iframeURL = ytURL.split('v=')[1];
      this.modalShow = true;
      this.ytVideo = '<iframe src="https://www.youtube.com/embed/' + iframeURL + '?rel=0&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>';
    },
    overlay() {
      this.modalShow = false;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/Tutorials.vue